import React, { useState } from 'react';
import { CheckSquare, Square, AlertTriangle } from 'lucide-react';

/**
 * Prerequisites — interactive checklist.
 * Props:
 *   items – array of strings
 *   theme – theme object
 *   onAllChecked – optional callback(allChecked: boolean)
 */
export default function Prerequisites({ items, theme, onAllChecked }) {
  const [checked, setChecked] = useState(() => items.map(() => false));

  const toggle = (idx) => {
    const next = [...checked];
    next[idx] = !next[idx];
    setChecked(next);
    onAllChecked?.(next.every(Boolean));
  };

  const checkedCount = checked.filter(Boolean).length;
  const allChecked = checkedCount === items.length;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-gray-500">
          {checkedCount}/{items.length} ready
        </span>
        {!allChecked && checkedCount > 0 && (
          <span className="flex items-center gap-1 text-xs text-amber-600 font-medium">
            <AlertTriangle className="w-3 h-3" />
            Some items unchecked
          </span>
        )}
      </div>
      <div className="space-y-2">
        {items.map((item, idx) => (
          <button
            key={idx}
            onClick={() => toggle(idx)}
            className={`w-full flex items-center gap-3 p-3 rounded-xl text-left transition-all duration-200 ${
              checked[idx]
                ? 'bg-emerald-50/80'
                : 'bg-gray-50 hover:bg-gray-100/80'
            }`}
          >
            {checked[idx] ? (
              <CheckSquare className="w-4.5 h-4.5 text-emerald-500 shrink-0" />
            ) : (
              <Square className="w-4.5 h-4.5 text-gray-300 shrink-0" />
            )}
            <span
              className={`text-sm ${
                checked[idx]
                  ? 'text-emerald-700 font-medium line-through decoration-emerald-300'
                  : 'text-gray-700'
              }`}
            >
              {item}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
